var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-column justify-center"},[_c('v-btn',{staticClass:"add-button",attrs:{"fab":"","elevation":"0"},on:{"click":function($event){return _vm.$emit('add')}}},[_c('v-icon',[_vm._v("fa-plus")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }